import configData from '../../fields/other/configData';

export const QUERY_GET_PRIVATE_CONFIG_DATA = /* GraphQL */ `
	query($id: String!) {
		getPrivateConfigData(id: $id) {
			${configData}
		}
	}
`;
